// Central place for values you should double check / replace.
export const WHATSAPP_NUMBER = "918857015469"; // used in your other client sites' footers
export const EMAIL = "himanshubakre572@gmail.com";
export const SOCIALS = {
  github: "https://github.com/himanshubakre",
  linkedin: "https://www.linkedin.com/in/himanshu-bakre-45b272252",
  x: "https://x.com/himanshubakre",
  instagram: "https://www.instagram.com/himanshubakre",
};
